// extracted by mini-css-extract-plugin
export default {"item":"SensorStatusItem_item__pG5Dl","selected":"SensorStatusItem_selected__ibhyW","count":"SensorStatusItem_count__qjzkJ","text":"SensorStatusItem_text__xdhBc"};